import { useQuery } from "@apollo/client/react";
import { Route, Routes, useParams } from "react-router";

import NotFoundPage from "components/error/NotFoundPage";
import PageLoading from "components/loading/PageLoading";
import useErrorHandle from "hooks/useErrorHandle";
import useHasModuleAdminAccess from "shared/Module/access/useHasModuleAdminAccess";
import useHasModuleWriteAccess from "shared/Module/access/useHasModuleWriteAccess";

import ModuleVersion from "./Version";
import ModuleVersions from "./Versions";
// import ModuleConsumers from "./Consumers";
import { ModuleContext } from "./Context";
import ModuleContexts from "./Contexts";
import Environment from "./Environment";
import ModuleNotifications from "./Notifications";
import ModulePolicies from "./Policies";
import ModulePullRequests from "./PullRequests";
import ModuleRun from "./Run";
import ModuleMainLayout from "./components/MainLayout";
import { GET_MODULE } from "./gql";
import { ModuleGQL } from "./types";

const Module = () => {
  const { moduleId } = useParams<{ moduleId: string }>();

  const { data, error, loading } = useQuery<ModuleGQL>(GET_MODULE, {
    variables: { id: moduleId },
    fetchPolicy: "no-cache",
  });

  const ErrorContent = useErrorHandle(error);

  const canManageModule = useHasModuleAdminAccess()(data?.module);
  const hasModuleWriteAccess = useHasModuleWriteAccess()(data?.module);

  if (ErrorContent) {
    return ErrorContent;
  }

  if (loading && !data?.module) {
    return <PageLoading />;
  }

  if (!data?.module) {
    return <NotFoundPage />;
  }

  const moduleContext = {
    module: data.module,
    canManageModule,
    hasModuleWriteAccess,
    moduleUrl: "",
  };

  return (
    <ModuleContext.Provider value={moduleContext}>
      <Routes>
        <Route element={<ModuleMainLayout />}>
          <Route index element={<ModuleVersions />} />
          <Route path="environment" element={<Environment />} />
          {/* <Route path="consumers" element={<ModuleConsumers />} /> */}
          <Route path="policies" element={<ModulePolicies />} />
          <Route path="contexts" element={<ModuleContexts />} />
          <Route path="prs" element={<ModulePullRequests />} />
          <Route path="notifications" element={<ModuleNotifications />} />
        </Route>

        <Route path="run/:runId">
          <Route index path="*" element={<ModuleRun />} />
        </Route>
        <Route path="version/:versionId">
          <Route index path="*" element={<ModuleVersion />} />
        </Route>
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </ModuleContext.Provider>
  );
};

export default Module;
